/* AppListingV2.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ResponsiveTabs } from '@atlassian/mpac-ui';
import React from 'react';
import { ELEMENT_ID, MAX_VISIBLE_TABS_CONFIG } from '../../../constants';
import { ListingHeader } from '../ListingHeader/ListingHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const BrandFontWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ect418aq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BrandFontWrapper.displayName = 'BrandFontWrapper';
}
const AppListingV2 = props => {
  const {
    appHeaderDetails,
    appRatingLink,
    appIconLink,
    bottomSeparator,
    headerInjection,
    hostingSelect,
    afterHeader,
    isAppCloudFortified,
    showInstallationCount,
    openMarketplaceLinksInNewTab,
    bugBountyParticipant,
    compatibilitySummary,
    lozenges,
    selectedTab,
    onTabChange,
    tabsData
  } = props;
  return /*#__PURE__*/_jsxs(BrandFontWrapper, {
    children: [/*#__PURE__*/_jsx(ListingHeader, {
      appHeaderDetails: appHeaderDetails,
      appRatingLink: appRatingLink,
      appIconLink: appIconLink,
      bottomSeparator: bottomSeparator,
      headerInjection: headerInjection,
      isAppCloudFortified: isAppCloudFortified,
      showInstallationCount: showInstallationCount,
      openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
      bugBountyParticipant: bugBountyParticipant,
      compatibilitySummary: compatibilitySummary,
      lozenges: lozenges,
      hostingSelect: hostingSelect,
      onTabChange: onTabChange
    }), afterHeader, /*#__PURE__*/_jsx(ResponsiveTabs, {
      id: ELEMENT_ID.APP_LISTING_TABS,
      selected: selectedTab,
      maxVisibleTabs: MAX_VISIBLE_TABS_CONFIG,
      onChange: selected => onTabChange(selected),
      tabs: tabsData
    })]
  });
};
export default AppListingV2;